import * as React from 'react';
import { Circle as VisxCircle } from '@visx/shape';
import { useTheme, useThemeRawValues } from '@leagueplatform/genesis-core';

export type CircleProps = React.ComponentProps<typeof VisxCircle>;

/**
 * Wraps the visx Circle component and applies genesis styles.
 */
export function Circle(props: CircleProps) {
  const theme = useTheme();
  const rawTheme = useThemeRawValues();

  const strokeWidth = rawTheme.space.quarter;
  const radii = (rawTheme.space.one + strokeWidth) / 2;

  return (
    <VisxCircle
      tabIndex={0}
      fill={
        theme.colors.dataVizSingleColorBrand ??
        theme.colors.decorativeBrandPrimaryDark
      }
      stroke={theme.colors.surfaceBackgroundPrimary}
      strokeWidth={strokeWidth}
      r={radii}
      style={{
        // Adds radius to the outline when focused.
        borderRadius: radii,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
